import React from "react";
import cs from "classnames";
import styles from "./styles.module.scss";
import { ChevronUpIcon, CopyIcon } from "../AppInsightsControls/icons";
import { McpWidgetProps } from "./types";

/**
 * MCP widget — the header pill with the connection status (Figma 4148:20563:
 * Default / Active / Opened) and, under it, the endpoint to hand a client
 * (Figma 4145:13248).
 * Dumb component: render it inside a `position: relative` wrapper; status,
 * open state, copying and outside clicks belong to the container.
 */
export const McpWidget: React.FC<McpWidgetProps> = ({
  connected = false,
  endpoint,
  open = false,
  onToggle,
  onCopy,
  copied = false,
  description = "Connect your MCP client using the endpoint below to get started.",
  className,
}) => (
  <div className={cs(styles.root, className)}>
    <button
      type="button"
      className={cs(styles.pill, {
        [styles.connected]: connected,
        [styles.open]: open,
      })}
      onClick={onToggle}
      aria-expanded={open}
      aria-haspopup="dialog"
    >
      <span className={styles.lead}>
        <span className={styles.title}>MCP</span>
        <span className={styles.status}>
          <span className={styles.dot} />
          {connected ? "Connected" : "Not connected"}
        </span>
      </span>
      <span className={styles.chevron}>
        <ChevronUpIcon />
      </span>
    </button>

    {open && (
      <div className={styles.panel} role="dialog" aria-label="MCP connection">
        <p className={styles.description}>{description}</p>
        <div className={styles.endpoint}>
          <span className={styles.endpointLabel}>Endpoint:</span>
          <div className={styles.endpointRow}>
            <div className={styles.field} title={endpoint}>
              <span className={styles.fieldText}>{endpoint}</span>
            </div>
            <button
              type="button"
              className={cs(styles.copy, { [styles.copied]: copied })}
              onClick={onCopy}
              aria-label={copied ? "Copied" : "Copy endpoint"}
              title={copied ? "Copied" : "Copy"}
            >
              <CopyIcon />
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
);

export default McpWidget;
